import React, { useContext } from 'react'
import styled from 'styled-components'
import { BlogContext } from '../context/BlogContextProvider'
const Blog = () => {
  const blogContext = useContext(BlogContext)
 
  function createMarkup() {
    return {
       __html: blogContext?.article?.description};
    }; 

  return (
    <>
    <BlogWrap>
        <ContentSection>
        <BlogTitle>
              {blogContext?.article?.heading}
        </BlogTitle>
       {
           blogContext?.article?.mainThumbnail &&
           <Thumbnail src={blogContext?.article?.mainThumbnail} />
       }
         <Content dangerouslySetInnerHTML={createMarkup()}>
           
         </Content>  
        </ContentSection>
    </BlogWrap>

    </>  
  )
}

export default Blog

const BlogWrap = styled.div`
  display: flex;
  justify-content: center;
  margin-top: 1rem;
  overflow-y: auto;
`
const ContentSection = styled.div`
  display: flex;
  flex-direction: column;
  background: ${({theme}) => theme.background};
  max-width: 60%;
  min-width: 60%;
  height: fit-content;
  padding: 1rem;
  border-top-right-radius: 10px;
  border-top-left-radius: 10px;
`
const BlogTitle = styled.div`
  display: flex;
`
const Content = styled.div`
  margin-top: 1rem;
  border-top: 1px solid white;
  padding: 0.8rem 0;
`
const Thumbnail = styled.img`
   max-width: 100%;
   width: 100%;
   object-fit: cover;
`